import type { ReactNode } from "react";
import { cx } from "../../lib/cx";

export type BadgeTone = "neutral" | "accent" | "sage" | "danger" | "outline" | "solid";

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

export function Badge({ tone = "neutral", children, className }: BadgeProps) {
  return <span className={cx("badge", tone !== "neutral" && `badge--${tone}`, className)}>{children}</span>;
}
